import { allowEnglishKoreanNumberBracketDash, allowUrlWebsite } from '@/utils';

import { ColumnTypes, EditableCellType } from '../common/table/type';

export const getColumns = (canEdit: boolean): ColumnTypes => [
	{
		align: 'center',
		title: 'ID',
		dataIndex: 'id',
		key: 'id',
		className: '!cursor-default',
	},
	{
		align: 'center',
		title: '웹 사이트 제목',
		dataIndex: 'title',
		key: 'title',
		editable: canEdit,
		cellType: EditableCellType.TEXT_INPUT,
		inputProps: {
			maxLength: 20,
			formatInput: allowEnglishKoreanNumberBracketDash,
		},
		className: `max-w-[200px] ${!canEdit ? '!cursor-default' : ''}`,
	},
	{
		align: 'center',
		title: '웹 사이트 URL',
		dataIndex: 'url',
		key: 'url',
		editable: canEdit,
		cellType: EditableCellType.TEXT_INPUT,
		inputProps: {
			maxLength: 200,
			formatInput: allowUrlWebsite,
		},
		className: `max-w-[200px] ${!canEdit ? '!cursor-default' : ''}`,
	},
	{
		align: 'center',
		title: '등록자',
		dataIndex: 'registName',
		key: 'registName',
		className: '!cursor-default',
	},
	{
		align: 'center',
		title: '등록일',
		dataIndex: 'registDt',
		key: 'registDt',
		className: '!cursor-default',
	},
];
